"use client";

import React from "react";
import { Select } from "@/components/ui/form-elements";
import { useGraphStore } from "@/store/graph-store";

interface LensPreset {
  name: string;
  description: string;
  categories: string[];
}

export const LENS_PRESETS: LensPreset[] = [
  {
    name: "Full Spectrum (Tutto)",
    description: "Visualizza tutti i nodi e le relazioni",
    categories: [
      "strategy",
      "people",
      "work",
      "sales",
      "finance",
      "operations",
      "risk",
      "documents",
      "innovation",
    ],
  },
  {
    name: "Strategy & Goals (Strategia)",
    description: "Focalizzato su obiettivi e visione strategica",
    categories: ["strategy", "people"],
  },
  {
    name: "Operations & Work (Operazioni)",
    description: "Visualizza team e progetti attivi",
    categories: ["work", "people", "operations"],
  },
  {
    name: "Financial Overview (Finanze)",
    description: "Evidenzia costi, budget e fatturato",
    categories: ["finance", "work"],
  },
  {
    name: "Risk & Mitigation (Rischi)",
    description: "Evidenzia aree critiche e blocker",
    categories: ["risk", "work", "strategy"],
  },
];

export function LensSelector() {
  const { visibleCategories, applyCategoryFilter } = useGraphStore();

  // Determine active preset based on visible categories
  const getActivePresetValue = () => {
    const visibleSet = new Set(visibleCategories);
    const activePreset = LENS_PRESETS.find(
      (preset) =>
        preset.categories.length === visibleCategories.length &&
        preset.categories.every((cat) => visibleSet.has(cat)),
    );
    return activePreset ? activePreset.name : "custom";
  };

  const handleSelectPreset = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const presetName = e.target.value;
    if (presetName === "custom") return;

    const preset = LENS_PRESETS.find((p) => p.name === presetName);
    if (preset) {
      applyCategoryFilter(preset.categories);
    }
  };

  return (
    <div className="flex flex-col gap-1 min-w-[180px]">
      <span className="text-[10px] font-bold uppercase tracking-wider text-text-muted select-none">
        Seleziona Lente
      </span>
      <Select
        value={getActivePresetValue()}
        onChange={handleSelectPreset}
        className="h-8 py-0 pl-2 pr-8 text-xs font-semibold bg-card border-border rounded-md shadow-sm"
      >
        {LENS_PRESETS.map((preset) => (
          <option key={preset.name} value={preset.name}>
            {preset.name}
          </option>
        ))}
        <option value="custom" disabled>
          Lente Personalizzata...
        </option>
      </Select>
    </div>
  );
}
